export const URLS = {
  OFFERS_BY_MERCHANT: '/app/transactions/offers',
  OFFER_PREVIEW: '/app/transactions/offers',
  TRANSACTIONS: '/app/transactions',
  OFFERS: '/app/offers',
  CUSTOMER: '/app/customers',
  LOGIN_CODE: '/app/auth/login/code',
  LOGIN: '/app/auth/login',
  PRE_CUSTOMER: '/app/pre-customers',
  UPGRADE_CUSTOMER: '/app/pre-customers/upgrade',
  VALIDATION_CUSTOMER: '/app/customers/validation',
  VALIDATE_CUSTOMER: '/app/customers/validate',
  PRE_LOANS: '/app/pre-loans',
  PAYMENTS: '/app/transactions/{transaction_id}/payments',
  REQUEST_PAYMENTS: '/app/transactions/{transaction_id}/payments/{payment_id}',
  CREATE_CREDIT_CARD: '/app/customers/card',
  GET_CARD: '/app/customers/card',
  MERCHANT_TRANSACTIONS: '/app/transactions',
  PUT_RECORD: '/api/metrics/put_record',
  GET_ORDER: '/app/transactions/transaction-order',
  GET_AVAILABLE_OFFERS: '/app/customers/offers',
  GET_AVAILABLE_SCORE: '/app/customers/available-score',
  GET_KEYNUA_WIDGET_TOKEN: '/app/customers/biometrics',
  GET_KEYNUA_WIDGET_STATUS: '/app/customers/biometrics',
  CUSTOMER_SCORE: '/app/customers/score',
  VALIDATION_AGGREGATOR: '/app/customers/validation/aggregator',
  VALIDATION_MAX_INSTALLMENT: '/app/customers/validation/max-installment',
  VALIDATION_DEBIT: '/app/customers/debit-validation',
  PROMOTIONS: '/promotions',
};

export const URLS_MOCK = {
  OFFERS_BY_MERCHANT: '/app/transactions/offers',
  OFFERS_BY_MERCHANT_AMOUNT: '/app/transactions/offers\\?amount=600.00',
  OFFER_PREVIEW: '/app/transactions/offers/preview',
  OFFER_PREVIEW_3:
    '/app/transactions/offers/preview\\?offer_id=c6e5e010-dc14-4f36-8176-adf256c84b0d\\&amount=600.00',
  OFFER_PREVIEW_6:
    '/app/transactions/offers/preview\\?offer_id=7a2e59a0-738f-4cd9-b4a0-09bfedbb542c\\&amount=600.00',
  OFFER_PREVIEW_12:
    '/app/transactions/offers/preview\\?offer_id=2ef46a70-be2e-4207-ab84-fba828a74cb3\\&amount=600.00',
  PRE_CUSTOMERS_STEP_1: '/app/pre-customers\\?step_onboarding=1',
  PRE_CUSTOMERS_STEP_2: '/app/pre-customers\\?step_onboarding=2',
  AVAILABLE_OFFERS: '/app/customers/offers\\?(transaction_id=[^&]+&)?session_id=[^&]+',
  AVAILABLE_SCORE:
    '/app/customers/available-score\\?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357\\&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357',
  KEYNUA_WIDGET_TOKEN: '/app/customers/biometrics',
  KEYNUA_WIDGET_STATUS: '/app/customers/biometrics',
  VALIDATION_CUSTOMER: '/app/customers/validation\\?(transaction_id=[^&]+&)?session_id=[^&]+',
  VALIDATION_AGGREGATOR:
    '/app/customers/validation/aggregator\\?(transaction_id=[^&]+&)?session_id=[^&]+',
  VALIDATION_MAX_INSTALLMENT:
    '/app/customers/validation/max-installment\\?(transaction_id=[^&]+&)?session_id=[^&]+',
  VALIDATION_DEBIT: '/app/customers/debit-validation\\?(transaction_id=[^&]+&)?session_id=[^&]+',
  CHECK_PENDING_PAYMENTS: '/app/transactions/28mockbf-377c-43b1-ba61-5ecc1mock357/payments',
  CREATE_PAYMENTS: '/app/transactions/28mockbf-377c-43b1-ba61-5ecc1mock357/payments',
};
